// extracted by mini-css-extract-plugin
export default {"container":"Header_container_RiZTd","header":"Header_header_SADXO","menu":"Header_menu_fbBqe","link":"Header_link_PnUT2","mail":"Header_mail_taoNm"};